import { useState } from "react";
import useCalendarSale from "../../hooks/useCalendarSale";
import { useSelector } from "react-redux";
import { State } from "../../../../store";
import useCustomOffer from "../../../CustomOffer/hooks/useCustomOffer";
import useFacility from "../../../../../utils/hooks/useFacility";

export enum SelectionState {
  NO_SELECTION = 0,
  DATE_SELECTED = 1,
  TIME_SELECTED = 2,
}

export default function useCalendarModal(exerciseName: string) {
  const [selectionState, setSelectionState] = useState<SelectionState>(SelectionState.NO_SELECTION);
  const facilityIds = useFacility();
  const { getSaleStepByStepId } = useCustomOffer();
  const foundedSaleStep = getSaleStepByStepId();
  const alwaysShowHoursToChoose = useSelector((state: State) => state.config.configuration.alwaysShowHoursToChoose);
  const [, showTimeToEntry] = useState(true);

  const {
    getHoursAvaiableByName,
    exercise,
    selectedDate,
    getDaysAvailableByName,
    listaDat,
    joinToExercise,
    alerts,
    firstAvailableDate,
    soldOutDates,
    isConfirmationModalOpen,
    toggleConfirmationModal,
  } = useCalendarSale();

  const refreshCapacityAfterAddTicket = () => {
    getHoursAvaiableByName(selectedDate, exerciseName, true);
  };

  const joinToExerciseByPass = (exerciseIds: string, assignType: boolean, passId: number) => {
    const StringPassId = "0," + passId;
    joinToExercise(Number(exerciseIds), assignType, StringPassId, () => refreshCapacityAfterAddTicket());
  };

  const handleDateSelection = () => {
    setSelectionState(SelectionState.DATE_SELECTED);
  };

  const handleTimeSelection = () => {
    if (selectionState >= SelectionState.DATE_SELECTED) {
      setSelectionState(SelectionState.TIME_SELECTED);
    }
  };

  const handleDateSelect = (date: Date, name: string) => {
    getHoursAvaiableByName(date, name);
    handleDateSelection();
  };

  const resetSelection = () => {
    setSelectionState(SelectionState.NO_SELECTION);
  };

  const modifiedAlwaysShowHoursToChoose =
    foundedSaleStep?.alwaysShowHoursToChooseInCalendarSale ?? alwaysShowHoursToChoose;

  //   const modifiedTimeToEntry = foundedSaleStep?.alwaysShowHoursToChooseInCalendarSale;

  const isDateSelected = selectionState >= SelectionState.DATE_SELECTED;
  const isTimeSelected = selectionState >= SelectionState.TIME_SELECTED;

  const init = () => {
    getDaysAvailableByName(exerciseName);

    if (exercise.length > 1) {
      showTimeToEntry(true);
    } else if (exercise.length === 1) {
      if (facilityIds === "1220" || facilityIds === "350" || facilityIds === "1228") {
        showTimeToEntry(true);
      } else {
        showTimeToEntry(false);
      }

      if (modifiedAlwaysShowHoursToChoose) {
        showTimeToEntry(true);
      } else {
        showTimeToEntry(false);
      }
    }
  };

  return {
    selectionState,
    handleDateSelection,
    handleTimeSelection,
    handleDateSelect,
    resetSelection,
    isDateSelected,
    isTimeSelected,
    refreshCapacityAfterAddTicket,
    joinToExerciseByPass,
    exercise,
    selectedDate,
    listaDat,
    firstAvailableDate,
    soldOutDates,
    alerts,
    isConfirmationModalOpen,
    toggleConfirmationModal,
    modifiedAlwaysShowHoursToChoose,
    init,
  };
}
